const REASONS = [
  {
    icon: 'ri-shield-check-line',
    title: 'Privacy Without Isolation',
    desc: 'The cabin sits in a secluded wooded setting that genuinely feels private — no neighbors in view, no road noise — while still being just a few minutes\' drive from downtown Highlands. That balance is rare and hard to find in any lodging category.',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Genuine Luxury Feel',
    desc: 'Stone fireplace, quality furnishings, a full gourmet kitchen, and an outdoor wood-burning fireplace on the covered deck. It feels like a real retreat — not a rental that happens to have nice photos.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Minutes from Downtown Highlands',
    desc: 'You\'re close enough to walk to dinner or browse Main Street, but far enough that you never feel like you\'re in town. Most Highlands lodging forces a trade-off between location and privacy — this cabin doesn\'t.',
  },
  {
    icon: 'ri-drop-line',
    title: 'Walking Distance to Glen Falls',
    desc: 'Glen Falls is one of the most beautiful waterfalls in the Blue Ridge Mountains. Most places to stay in Highlands, NC require a drive to reach it. This cabin is within walking distance of the trailhead.',
  },
  {
    icon: 'ri-star-line',
    title: '5.0 Guest Favorite Rating',
    desc: 'A 5.0-star Airbnb Guest Favorite rating is genuinely difficult to maintain. Guests consistently note the quality of the space, the peaceful setting, and the attentive hosting — not just once, but across many stays.',
  },
  {
    icon: 'ri-group-line',
    title: 'Works for Different Trips',
    desc: 'Whether you\'re planning a romantic weekend, a family trip, or a small group getaway, the cabin accommodates up to 6 guests comfortably. It\'s pet friendly too — one of the better options in Highlands for traveling with dogs.',
  },
];

export default function PTSWhyGlenFallsSection() {
  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div className="rounded-2xl overflow-hidden h-[540px] lg:sticky lg:top-24">
            <img
              src="https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/6621c51b505ccdecc14eea48184d7049.jpeg"
              alt="Glen Falls Luxury Cabin — top place to stay in Highlands NC"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Why It Ranks #1</p>
            <h2 className="font-cormorant text-4xl md:text-5xl text-[#1A1A18] font-light mb-4 leading-tight">
              Why Glen Falls Luxury Cabin<br /><em className="italic">Stands Out</em>
            </h2>
            <div className="w-12 h-px bg-[#C9A96E] mb-7" />
            <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-10">
              Among all the places to stay in Highlands, NC, Glen Falls Luxury Cabin earns the top spot because it gets the combination right in a way that most properties — cabins or hotels — don&apos;t. Here&apos;s what sets it apart:
            </p>
            <div className="space-y-6">
              {REASONS.map((r) => (
                <div key={r.title} className="flex items-start gap-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white shrink-0 mt-0.5">
                    <i className={`${r.icon} text-[#2D4A3E] text-base`} />
                  </div>
                  <div>
                    <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium mb-1.5">{r.title}</h3>
                    <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{r.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-10">
              <a
                href="https://glenfallscabin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#2D4A3E] text-white text-xs tracking-[0.2em] uppercase font-jost font-medium px-8 py-4 rounded-full hover:bg-[#1e3329] transition-colors cursor-pointer whitespace-nowrap"
              >
                View Glen Falls Luxury Cabin
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line text-xs" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
